<template>
  <div>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }"><v-icon>mdi-image-area-close</v-icon></v-btn>
        </template>
        <span>Выгрузка изображений</span>
      </v-tooltip>
    </template>
      <v-list style="max-height:500px;overflow-y:auto">
        <v-list-item @click="performSearch('Выгрузка изображений ссылками')"><v-list-item-title>Выгрузка изображений ссылками</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка Озон изображений ссылками')"><v-list-item-title>Выгрузка Озон изображений ссылками</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка WB изображений ссылками')"><v-list-item-title>Выгрузка WB изображений ссылками</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка Леруа изображений ссылками')"><v-list-item-title>Выгрузка Леруа изображений ссылками</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка инструкций ссылками')"><v-list-item-title>Выгрузка инструкций ссылками</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка ЭТМ изображений ссылками')"><v-list-item-title>Выгрузка ЭТМ изображений ссылками</v-list-item-title></v-list-item>
        <v-divider/>
        <v-list-item @click="performSearch('Выгрузка изображений архивом')"><v-list-item-title>Выгрузка изображений архивом</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка Озон изображений архивом')"><v-list-item-title>Выгрузка Озон изображений архивом</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка WB изображений архивом')"><v-list-item-title>Выгрузка WB изображений архивом</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка Леруа изображений архивом')"><v-list-item-title>Выгрузка Леруа изображений архивом</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка Петрович изображений архивом')"><v-list-item-title>Выгрузка Петрович изображений архивом</v-list-item-title></v-list-item>
        <v-list-item @click="performSearch('Выгрузка ЭТМ изображений архивом')"><v-list-item-title>Выгрузка ЭТМ изображений архивом</v-list-item-title></v-list-item>
        <v-divider v-if="isAdmin" />
        <v-list-item v-if="isAdmin" @click="historyExportDialogRef = true"><v-list-item-title>Выгрузка истории изменений</v-list-item-title></v-list-item>
      </v-list>
  </v-menu>
  <v-dialog v-model="dialogRef" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Параметры поиска</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="formRef" lazy-validation>
                  <v-checkbox v-if="mainImageVisibleRef" v-model="mainImageRef" label="Основное изображение" required></v-checkbox>
                  <v-text-field type="number" v-model="imageNumRef" label="Номер изображения" clearable required></v-text-field>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary darken-1" text @click="dialogRef = false">Закрыть</v-btn>
          <v-btn color="primary darken-1" text @click="doSearch">Выгрузить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="historyExportDialogRef" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Выгрузка истории изменений</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="formRef" lazy-validation>
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateFromRef" label="С даты" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="dateFromRef" @input="menu = false"></v-date-picker>
                  </v-menu>
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateToRef" label="По дату" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="dateToRef" @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary darken-1" text @click="historyExportDialogRef = false">Закрыть</v-btn>
          <v-btn color="primary darken-1" text @click="exportHistory">Выгрузить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import * as usersStore from '../../../store/users'

export default {
  props: {
    headers: {
      required: true
    },
    columnsSelected: {
      required: true
    },
    items: {
      required: true
    },
    loadData: {
      required: true
    },
    processButtonAction: {
      required: true
    }
  },
  setup (props) {
    const { isAdmin } = usersStore.useStore()

    const dialogRef = ref(null)
    const historyExportDialogRef = ref(null)

    const mainImageRef = ref(true)
    const mainImageVisibleRef = ref(false)
    const imageNumRef = ref(null)

    const dateFromRef = ref(null)
    const dateToRef = ref(null)

    let buttonText = null
    function performSearch (button) {
      buttonText = button
      mainImageRef.value = true
      mainImageVisibleRef.value = (buttonText === 'Выгрузка изображений ссылками' || buttonText === 'Выгрузка изображений архивом')
      dialogRef.value = true
    }

    function doSearch () {
      dialogRef.value = false
      const data = { mainImage: mainImageRef.value, imageNum: imageNumRef.value }
      // console.log(buttonText, JSON.stringify(data))
      props.processButtonAction(buttonText, JSON.stringify(data))
    }

    function exportHistory () {
      historyExportDialogRef.value = false
      const data = { dateFrom: dateFromRef.value, dateTo: dateToRef.value }
      // console.log(buttonText, JSON.stringify(data))
      props.processButtonAction('historyExport', JSON.stringify(data))
    }

    return {
      dialogRef,
      historyExportDialogRef,
      mainImageRef,
      imageNumRef,
      mainImageVisibleRef,
      performSearch,
      doSearch,
      isAdmin,
      dateFromRef,
      dateToRef,
      exportHistory
    }
  }
}
</script>
